// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_09d5b","row":"_86934","menu":"_74e63","content":"_5b6a5"};